<template>
  <section ref="anchor" class="employees">
    <div class="employees__content">
      <div
        v-for="(tile, index) in content.tiles"
        :key="index"
        class="employees__content-item"
      >
        <img
          v-if="tile.img"
          :src="`/img/${tile.img}`"
          class="employees__content-image"
        />

        <div
          v-else
          :class="['employees__content-block', { 'mod-gray': tile.background }]"
        >
          <div class="font-32-40 employees__title">{{ tile.title }}</div>

          <div class="employees__clue">Тип</div>

          <div class="font-medium block__description">{{ tile.type }}</div>

          <div class="employees__clue">Где</div>

          <div class="font-medium block__description">{{ tile.where }}</div>

          <div class="employees__clue">Зачем</div>

          <div class="font-medium block__description">{{ tile.why }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { electronicEmployeesData } from '@/content/data'
import offsetMixin from '@/mixins/offsetMixin'

export default {
  name: 'ElectronicEmployees',
  mixins: [offsetMixin],
  data() {
    return {
      content: electronicEmployeesData,
    }
  },
}
</script>

<style lang="sass" scoped>
.employees
  padding: 0 $desktopHorizontalPaddings 8rem
  @media (max-width: 1279px)
    padding: 0 $mobileHorizontalPaddings 4rem
  @media (max-width: 767px)
    padding: 0 1.6rem 4rem
  &__title
    color: $textPrimary
    font-weight: 500
    @media (min-width: 1280px) and (max-width: 1439px)
      font-size: 3.2rem
      line-height: 4rem
    @media (max-width: 1279px)
      font-size: 3.2rem
      line-height: 4rem
  &__clue
    font-family: $secondaryFont
    font-weight: 400
    font-size: 1.8rem
    line-height: 2.4rem
    color: $textGray
    @media (min-width: 1280px) and (max-width: 1439px)
      font-size: 2.2rem
      line-height: 2.6rem
    @media (max-width: 1279px)
      font-size: 2.2rem
      line-height: 2.6rem
  &__content
    display: grid
    grid-template-columns: repeat(3, 1fr)
    gap: 2rem
    margin-top: 6rem
    @media (max-width: 1439px)
      grid-template-columns: repeat(2, 1fr)
    @media (max-width: 767px)
      grid-template-columns: 1fr
    .employees__content-item
      min-height: 40rem
      display: flex
      @media (max-width: 1439px)
        min-height: 35rem
      @media (max-width: 767px)
        min-height: 30rem
      & > *
        width: 100%

    @media (min-width: 768px) and (max-width: 1279px)
      margin-top: 4rem
      gap: 1.6rem

    @media (max-width: 767px)
      margin-top: 2.4rem
      gap: 1.2rem

    &-image
      width: 100%
      height: 100%
      border-radius: 20px
      object-fit: cover
      object-position: center
      @media (max-width: 1279px)
        border-radius: 16px

    &-block
      display: flex
      flex-direction: column
      justify-content: flex-start
      gap: 1.2rem
      height: 100%
      padding: 3.2rem 2.4rem
      border-radius: 20px
      border: 1px solid $backgroundGray
      overflow-y: auto
      @media (min-width: 1440px) and (max-width: 1599px)
        padding: 2.2rem 1.4rem
        gap: 0.8rem
      @media (min-width: 1280px) and (max-width: 1439px)
        padding: 2.2rem 1.4rem
        gap: 0.8rem
      @media (max-width: 1279px)
        padding: 1.6rem 1.4rem
        gap: 0.6rem
      .block__description
        font-weight: 400
        margin-bottom: 0.8rem
        color: $textSecondary
        &:last-child
          margin-bottom: 0
        @media (min-width: 1280px) and (max-width: 1439px)
          font-size: 2.2rem
          line-height: 2.6rem
        @media (max-width: 1279px)
          font-size: 2.2rem
          line-height: 2.6rem
      &.mod-gray
        background: $backgroundGray
</style>
